// components/Modals/ContactUsModal.jsx
import React, {useContext} from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./ImageSliderModal.css";
import { FaTimes } from "react-icons/fa";
import { IMAGES_BASE_URL } from "../../../api/config";
import { useTranslateKey } from "../../translation/useTranslateKey";

const ImageSlider = ({ modalstyle, show, onClose, thumbImages }) => {
  const t = useTranslateKey();
  if (!show) return null;
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    customPaging: (i) => (
      <div className="dot-container">
        <img
          src={`${thumbImages[i]}`}
          alt={`Thumbnail ${i}`}
          className="dot-image"
        />
      </div>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div
      className={
        modalstyle
          ? "fixed inset-0 flex items-start justify-center z-50 pt-20"
          : ""
      }
      style={modalstyle ? { backgroundColor: "rgba(18, 21, 37, 0.98)" } : {}}
    >
      <div
        className={
          modalstyle
            ? "modal-container bg-[#11132F] border-2 border-[#332D7E] rounded-xl p-8 w-full mx-4 relative shadow-2xl"
            : ""
        }
      >
        <div
          className={
            modalstyle
              ? "mb-4 flex justify-between items-center"
              : "image-galary-mobile flex justify-between items-center"
          }
        >
          {modalstyle && (
            <>
              <h3 className="text-2xl font-bold text-white mb-6">
                {t("propertyImages")}
              </h3>
              <button
                className="w-8 h-8 bg-[#F9C835] text-[#121525] rounded-full flex items-center justify-center hover:bg-[#332D7E] hover:text-white transition-all duration-300"
                onClick={onClose}
              >
                <FaTimes className="text-2xl" />
              </button>
            </>
          )}
        </div>

        <Slider {...sliderSettings} className="image-slider">
          {thumbImages.map((img, i) => (
            <div className="px-4">
              <img
                key={i}
                src={`${img}`}
                alt={`Gallery ${i}`}
                className="h-32 w-full object-cover rounded cursor-pointer"
                onClick={() => {
                  // setMainImage(img);
                  // setShowModal(false);
                }}
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default ImageSlider;
